"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MercadoPagoBasisTheoryPaymentProcessor = MercadoPagoBasisTheoryPaymentProcessor;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _MercadoPagoBasisTheoryPending = _interopRequireDefault(require("./MercadoPagoBasisTheoryPending"));
var _LoadingScreen = _interopRequireDefault(require("@/components/LoadingScreen"));
var _useUserPreferences2 = _interopRequireDefault(require("@/hooks/useUserPreferences"));
var _actions = require("@/actions");
var _purchase = require("@/actions/purchase");
var _mercadoPagoBasisTheoryPayment = require("@/services/mercadoPagoBasisTheoryPayment");
var _MercadoPagoBasisTheoryChallenge = _interopRequireDefault(require("./MercadoPagoBasisTheoryChallenge"));
var _purchaseReader = require("./purchaseReader");
var _attempt = require("./attempt");
var _routeMode = require("./routeMode");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/** Own only the submitted BT MercadoPago attempt; all requests here are read-only. */
function MercadoPagoBasisTheoryPaymentProcessor(_ref) {
  var token = _ref.token,
    paymentId = _ref.paymentId,
    history = _ref.history,
    initialMode = _ref.initialMode,
    search = _ref.search;
  var dispatch = (0, _reactRedux.useDispatch)();
  var frontlineHost = (0, _reactRedux.useSelector)(function (state) {
    return state.whitelabelConfig.env.frontline.host;
  });
  var preSelectedSeats = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.get('preSelectedSeats');
  });
  var _useUserPreferences = (0, _useUserPreferences2["default"])(),
    passengers = _useUserPreferences.passengers;
  var hasPreSelectedSeats = false;
  if ((0, _typeof2["default"])(preSelectedSeats) === 'object' && preSelectedSeats !== null) {
    hasPreSelectedSeats = 'size' in preSelectedSeats && typeof preSelectedSeats.size === 'number' ? preSelectedSeats.size > 0 : Object.keys(preSelectedSeats).length > 0;
  }
  var hasFrequentPassengers = Boolean(passengers.length);
  var _useState = (0, _react.useState)({
      state: initialMode === 'reconcile' ? 'reconcile' : 'loading'
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    phase = _useState2[0],
    setPhase = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      return initialMode === 'reconcile' ? Date.now() + 4000 : 0;
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
    reloadReconcileAfter = _useState4[0];
  var showPending = (0, _react.useCallback)(function () {
    (0, _attempt.clearMercadoPagoBasisTheoryAttempt)(token, paymentId);
    setPhase({
      state: 'pending'
    });
  }, [token, paymentId]);
  var finish = (0, _react.useCallback)(function (payment) {
    (0, _attempt.clearMercadoPagoBasisTheoryAttempt)(token, paymentId, true);
    dispatch((0, _purchase.receivePayment)((0, _attempt.mercadoPagoBasisTheoryReceipt)(payment)));
    switch (payment.status) {
      case 'charged':
      case 'unsafe':
      case 'fully_refunded':
      case 'partially_refunded':
        history.replace("/purchase/".concat(token, "/complete?trackPurchase=true&seatsOnResults=").concat(hasPreSelectedSeats, "&frequentPassengers=").concat(hasFrequentPassengers));
        break;
      case 'suspicious':
        window.location.assign("".concat(window.location.protocol, "//").concat(frontlineHost, "/purchases/").concat(token, "/pending"));
        break;
      case 'failed':
      case 'rejected':
      case 'canceled':
        history.replace("/payment/".concat(token, "/").concat(paymentId, "/failure"));
        break;
      case 'chargeback':
        dispatch((0, _actions.setError)(301, 'error_when_generating_purchase', 'error', true, undefined, undefined, undefined, undefined, undefined));
        break;
      default:
        history.replace("/purchase/".concat(token, "/complete"));
    }
  }, [dispatch, history, token, paymentId, frontlineHost, hasPreSelectedSeats, hasFrequentPassengers]);
  var finishRef = (0, _react.useRef)(finish);
  (0, _react.useEffect)(function () {
    finishRef.current = finish;
  }, [finish]);
  (0, _react.useEffect)(function () {
    if (phase.state === 'challenge' || phase.state === 'pending') return undefined;
    var controller = new AbortController();
    var handled = false;
    // Abort state can change while an awaited request is in flight.
    function isAborted() {
      return controller.signal.aborted;
    }
    var refreshedPurchase = false;
    var purchaseRefresh;
    function refreshPurchase() {
      return _refreshPurchase.apply(this, arguments);
    }
    function _refreshPurchase() {
      _refreshPurchase = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var force,
          request,
          _args = arguments;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              force = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              if (!(refreshedPurchase && !force)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", undefined);
            case 1:
              if (!purchaseRefresh) {
                _context.next = 3;
                break;
              }
              _context.next = 2;
              return purchaseRefresh;
            case 2:
              if (force) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", undefined);
            case 3:
              refreshedPurchase = true;
              request = (0, _mercadoPagoBasisTheoryPayment.awaitMercadoPagoBasisTheoryRead)(function (signal) {
                return Promise.resolve().then(function () {
                  return (0, _purchaseReader.readMercadoPagoPurchase)(token, undefined, signal);
                });
              }, controller.signal, 30000).then(function (response) {
                if (isAborted()) throw new _mercadoPagoBasisTheoryPayment.MercadoPagoBasisTheoryPollingError('aborted');
                if ((0, _typeof2["default"])(response) !== 'object' || response === null || !('purchase' in response) || (0, _typeof2["default"])(response.purchase) !== 'object' || response.purchase === null || !('state' in response.purchase) || typeof response.purchase.state !== 'string') {
                  throw new _mercadoPagoBasisTheoryPayment.MercadoPagoBasisTheoryPollingError('invalid_response');
                }
                try {
                  dispatch((0, _purchase.receivePurchase)(response));
                  return response.purchase.state;
                } catch (_unused) {
                  throw new _mercadoPagoBasisTheoryPayment.MercadoPagoBasisTheoryPollingError('invalid_response');
                }
              });
              purchaseRefresh = request;
              _context.prev = 4;
              _context.next = 5;
              return request;
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
              _context.prev = 6;
              if (purchaseRefresh === request) purchaseRefresh = undefined;
              return _context.finish(6);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4,, 6, 7]]);
      }));
      return _refreshPurchase.apply(this, arguments);
    }
    function finishWithPurchase(_x) {
      return _finishWithPurchase.apply(this, arguments);
    }
    function _finishWithPurchase() {
      _finishWithPurchase = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(payment) {
        var state;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!['charged', 'unsafe', 'fully_refunded', 'partially_refunded'].includes(payment.status)) {
                _context2.next = 3;
                break;
              }
              _context2.next = 1;
              return refreshPurchase(true);
            case 1:
              state = _context2.sent;
              if (!controller.signal.aborted) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              if (!(state !== 'completed' && state !== 'pending')) {
                _context2.next = 3;
                break;
              }
              showPending();
              return _context2.abrupt("return");
            case 3:
              if (!controller.signal.aborted) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              handled = true;
              finishRef.current(payment);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _finishWithPurchase.apply(this, arguments);
    }
    function receive(payment) {
      if (isAborted() || handled) return;
      if (payment.id !== paymentId) throw new _mercadoPagoBasisTheoryPayment.MercadoPagoBasisTheoryPollingError('invalid_response');
      dispatch((0, _purchase.receivePayment)((0, _attempt.mercadoPagoBasisTheoryReceipt)(payment)));
      if (payment.status === 'charged' && payment.purchaseState === 'attempt') void refreshPurchase()["catch"](function () {
        // The terminal reconciliation below retries the purchase read.
      });
    }
    function prepareChallenge(attempt) {
      var _readMercadoPagoBasis;
      if (attempt.payment.id !== paymentId) {
        throw new _mercadoPagoBasisTheoryPayment.MercadoPagoBasisTheoryPollingError('invalid_response');
      }
      var completed = (_readMercadoPagoBasis = (0, _attempt.readMercadoPagoBasisTheoryOwnership)(token, paymentId)) === null || _readMercadoPagoBasis === void 0 ? void 0 : _readMercadoPagoBasis.challengeCompleted;
      if (attempt.payment.status !== 'pending' || !attempt.payment.using3dSecure || completed) return false;
      // A pending payment can precede its challenge or approval. Keep reading the
      // same attempt until a valid challenge arrives or the polling budget expires.
      if (attempt.invalidChallenge || !attempt.challenge) return false;
      receive(attempt.payment);
      handled = true;
      controller.abort();
      (0, _attempt.clearMercadoPagoBasisTheoryAttempt)(token, paymentId);
      setPhase({
        state: 'challenge',
        challenge: attempt.challenge
      });
      return true;
    }
    function run() {
      return _run.apply(this, arguments);
    }
    function _run() {
      _run = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var _readMercadoPagoBasis2, cached, reconcileAfter, delayMs, result, _t;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              cached = phase.state === 'loading' ? (0, _attempt.takeMercadoPagoBasisTheoryAttempt)(token, paymentId) : undefined;
              if (!(cached && prepareChallenge(cached))) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              if (!(cached && (['failed', 'rejected', 'suspicious', 'canceled', 'chargeback'].includes(cached.payment.status) || cached.payment.status === 'charged' && ['completed', 'pending'].includes(cached.payment.purchaseState)))) {
                _context4.next = 3;
                break;
              }
              _context4.next = 2;
              return finishWithPurchase(cached.payment);
            case 2:
              return _context4.abrupt("return");
            case 3:
              // Preserve the initial settle delay; elapsed time does not prove a final payment result.
              reconcileAfter = (_readMercadoPagoBasis2 = (0, _attempt.readMercadoPagoBasisTheoryOwnership)(token, paymentId)) === null || _readMercadoPagoBasis2 === void 0 ? void 0 : _readMercadoPagoBasis2.reconcileAfter;
              delayMs = Math.min(4000, Math.max(0, (reconcileAfter !== null && reconcileAfter !== void 0 ? reconcileAfter : reloadReconcileAfter) - Date.now()));
              if (!(delayMs > 0)) {
                _context4.next = 4;
                break;
              }
              _context4.next = 4;
              return (0, _mercadoPagoBasisTheoryPayment.sleepMercadoPagoBasisTheory)(controller.signal, delayMs);
            case 4:
              if (!controller.signal.aborted) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return");
            case 5:
              _context4.next = 6;
              return (0, _mercadoPagoBasisTheoryPayment.pollMercadoPagoBasisTheoryPayment)({
                expectedPaymentId: paymentId,
                signal: controller.signal,
                loadPayment: function () {
                  var _loadPayment = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(signal) {
                    var response, payment, attempt;
                    return _regenerator["default"].wrap(function (_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 1;
                          return (0, _purchaseReader.readMercadoPagoPurchase)(token, paymentId, signal);
                        case 1:
                          response = _context3.sent;
                          if (!(signal.aborted || controller.signal.aborted)) {
                            _context3.next = 2;
                            break;
                          }
                          return _context3.abrupt("return", response);
                        case 2:
                          payment = (0, _mercadoPagoBasisTheoryPayment.normalizeMercadoPagoBasisTheoryPayment)(response);
                          if (!(!payment || payment.id !== paymentId)) {
                            _context3.next = 3;
                            break;
                          }
                          throw new _mercadoPagoBasisTheoryPayment.MercadoPagoBasisTheoryPollingError('invalid_response');
                        case 3:
                          if (phase.state === 'loading') {
                            attempt = (0, _attempt.captureMercadoPagoBasisTheoryAttempt)(token, response);
                            prepareChallenge(attempt);
                            (0, _attempt.clearMercadoPagoBasisTheoryAttempt)(token, paymentId);
                          }
                          return _context3.abrupt("return", response);
                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function loadPayment(_x2) {
                    return _loadPayment.apply(this, arguments);
                  }
                  return loadPayment;
                }(),
                onPayment: receive
              });
            case 6:
              result = _context4.sent;
              if (!(isAborted() || handled)) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return");
            case 7:
              _context4.next = 8;
              return finishWithPurchase(result);
            case 8:
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _t = _context4["catch"](0);
              if (!(isAborted() || handled)) {
                _context4.next = 10;
                break;
              }
              return _context4.abrupt("return");
            case 10:
              if (!(_t instanceof _mercadoPagoBasisTheoryPayment.MercadoPagoBasisTheoryPollingError && _t.reason === 'aborted')) {
                _context4.next = 11;
                break;
              }
              return _context4.abrupt("return");
            case 11:
              handled = true;
              showPending();
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 9]]);
      }));
      return _run.apply(this, arguments);
    }
    void run();
    return function () {
      controller.abort();
      (0, _attempt.clearMercadoPagoBasisTheoryAttempt)(token, paymentId);
    };
  }, [phase.state, dispatch, token, paymentId, showPending, reloadReconcileAfter]);
  var onComplete = (0, _react.useCallback)(function () {
    history.replace((0, _routeMode.mercadoPagoBasisTheoryRoute)(token, paymentId, search, 'reconcile'));
    (0, _attempt.completeMercadoPagoBasisTheoryChallenge)(token, paymentId);
    setPhase({
      state: 'reconcile'
    });
  }, [token, paymentId, history, search]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, phase.state !== 'challenge' ? /*#__PURE__*/_react["default"].createElement(_MercadoPagoBasisTheoryPending["default"], {
    token: token,
    paymentId: paymentId,
    checking: phase.state !== 'pending',
    onVerify: function onVerify() {
      setPhase({
        state: 'reconcile'
      });
    }
  }) : /*#__PURE__*/_react["default"].createElement(_LoadingScreen["default"], null), phase.state === 'challenge' ? /*#__PURE__*/_react["default"].createElement(_MercadoPagoBasisTheoryChallenge["default"], {
    challenge: phase.challenge,
    paymentId: paymentId,
    onComplete: onComplete,
    onError: showPending
  }) : null);
}